var map = {
	"./en/achievements.json": 509,
	"./en/arena.json": 1,
	"./en/battle.json": 568,
	"./en/chat.json": 236,
	"./en/common.json": 251,
	"./en/craft.json": 916,
	"./en/dungeon.json": 768,
	"./en/gameData.json": 776,
	"./en/inventory.json": 714,
	"./en/market.json": 934,
	"./en/selection.json": 340,
	"./en/social.json": 237,
	"./en/tutorial.json": 84,
	"./en/village.json": 418,
	"./en/wiki.json": 538,
	"./tr/achievements.json": 917,
	"./tr/arena.json": 968,
	"./tr/battle.json": 207,
	"./tr/chat.json": 27,
	"./tr/common.json": 380,
	"./tr/craft.json": 749,
	"./tr/dungeon.json": 121,
	"./tr/gameData.json": 159,
	"./tr/inventory.json": 271,
	"./tr/market.json": 557,
	"./tr/selection.json": 697,
	"./tr/social.json": 198,
	"./tr/tutorial.json": 487,
	"./tr/village.json": 699,
	"./tr/wiki.json": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 943;